<template>
  <div class="targeting-page">
    <p class="mt-2">{{ totalCount }}</p>
      <div class="header-row mt-3">
        <p>ลูกค้า</p>
        <p>บ้าน</p>
        <p>รายละเอียดบริการ</p>
        <p>ผู้ชี้เป้า</p>
        <p>วันที่ชี้เป้า</p>
        <p>วันหมดอายุ</p>
        <p>สถานะ</p>
      </div>
      <div
        class="content-row"
        v-for="(item, index) in TargetingItems"
        :key="index"
        @click="
          $router.push({
            name: 'LeadManagementTargetingPage',
            params: { targetingId: item.id }
          })
        "
        style="cursor: pointer;"
      >
        <div>
          <p class="title">
            {{ item.user_full_name }}
          </p>
          <p>{{ item.user_mobile_number }}</p>
        </div>
        <div>
          <p class="title">
            {{ item.address_no }}
          </p>
          <p>{{ item.project_name }}</p>
        </div>
        <div>
          <p class="title">{{ item.category }}</p>
        </div>
        <div>
          <p class="title">{{ item.targeting_admin_full_name }}</p>
        </div>
        <div>
          <p>{{ displayDateFormat(item.estimated_purchase_at) }}</p>
        </div>
        <div>
          <p>{{ displayDateFormat(item.expired_at) }}</p>
        </div>
        <div>
          <p
            class="title"
            :class="statusClassList(item.action_status)"
          >
            {{ statusText(item.action_status) }}
          </p>
        </div>
      </div>
      <div class="text-right mt-4" v-if="TargetingItems.length">
        <div class="text-right">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="limit"
            :current-page="queryParams.page"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>
      <div v-else class="text-center p-5">ไม่พบข้อมูล</div>
  </div>
</template>

<script>
import ProjectSelect from "@/lib/components/ProjectSelect";
import ScButton from "../../../lib/components/ScButton.vue";
import UserSelect from "@/lib/components/UserSelect";
import { baanRueJaiClient } from "@/dependencies";
import { DateTime } from "luxon";
import { toLocaleTH } from "@/lib/dateTime";

export default {
  components: {
    ScButton,
    UserSelect,
    ProjectSelect,
  },
  data() {
    const targetingStatusOptions = [
      { id: "ACTIVE", name: "รอติดต่อ" },
      { id: "FOLLOW_UP", name: "รอติดตาม" },
      { id: "PURCHASED", name: "ซื้อแล้ว" },
      { id: "NOT_PURCHASE", name: "ไม่ซื้อ" },
      { id: "EXPIRED", name: "หมดอายุ" }
    ];
    const pagination = {
      page: 1,
      limit: 20,
      total: 0
    };

    return {
      targetingStatusOptions,
      TargetingItems: [],
      total: 0,
      query: {
        page: 1
      },
      ...pagination
    };
  },
  computed: {
    queryParams() {
      return {
        page: parseInt(this.$route.query.page) || 1,
        limit: this.limit
      };
    },
    totalCount() {
      const limit = this.limit;
      const total = this.total;
      const currentTotalItem = this.TargetingItems.length;
      const isLastPage = limit > currentTotalItem;
      const currentPage = this.queryParams.page;
      const end = isLastPage ? total : currentPage * limit;
      const start = (
        (isLastPage ? limit * currentPage - limit : end - limit) + 1
      ).toLocaleString();

      return `แสดงผล ${start} - ${end} จากทั้งหมด ${total}`;
    }
  },

  created() {
    this.setupData();
    this.setupQuery();
  },
  methods: {
    async setupData() {
      await this.setupTargetings();
    },
    async setupTargetings() {
      try {
        const params = {
          limit: this.limit,
          page: this.queryParams.page
        };

        const result = await this.fetchTargetingItems(params);

        this.TargetingItems = result.items;
        this.total = result.pagination.total_records;
      } catch (error) {
        throw error;
      }
    },
    async fetchTargetingItems(query) {
      try {
        const response = await baanRueJaiClient.admin.lead.getTargetingList(
          query
        );

        return response.data.result;
      } catch (error) {
        throw error;
      }
    },
    async handleCurrentChange(page) {
      const route = {
        query: { ...this.$route.query, page }
      };

      this.$router.replace(route);
    },
    setupQuery() {
      this.query = {
        page: parseInt(this.$route.query.page) || 1
      };
    },
    displayDateFormat(dateTime) {
      return dateTime
        ? this.dateTimeTH(dateTime)
        : null;
    },
    dateTimeTH(dateTime) {
      return toLocaleTH(DateTime.fromISO(dateTime)).toFormat("dd/MM/yyyy");
    },
    statusClassList(status) {
      if (!status) {
        return ["status"];
      }

      return ["status", status.toLowerCase()];
    },
    statusText(status) {
      return this.targetingStatusOptions.find(
        (option) => option.id === status
      ).name;
    }
  },
  watch: {
    async "$route.query"() {
      this.setupQuery();
      await this.setupData();
    }
  }
};
</script>

<style lang="scss">
@import "~@/lib/scss/variables";

.targeting-page {
  background-color: white;
  border-radius: 10px;
  width: 100%;
  padding: 16px;
}

.header-row, .content-row {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-gap: 8px;
  border-bottom: 1px solid #D9D9D9;
}

.header-row {
  background: #F1F1F1;
  padding: 8px;

  p {
    font-size: 14px;
    color: #707070;
    margin: 0;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0 4px;
  }
}

.content-row {
  background: white;
  padding: 12px 8px;
  cursor: pointer;

  .title {
    font-weight: 700;
    color: #4A4A4A;
  }

  p {
    font-size: 16px;
    color: #2E2E2E;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  div {
    padding: 0 4px;
    overflow: hidden;
  }

  &:hover,
  &:focus {
    background: #f6f6f6;
  }
}


.status {
  font-weight: bold;

  &.active {
    color: #2196F3;
  }

  &.follow_up {
    color: #FF9800;
  }

  &.purchased {
    color: #4CAF50;
  }

  &.not_purchase {
    color: #F44336;
  }

  &.expired {
    color: #9E9E9E;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/lead-management/pages/TargetingTab.vue